import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link, useParams } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

// Backend
import { getTicketDetail } from "connection/backend";

// actions
import { rateCreate, ticketUpdate } from "store/actions";

const TicketUpdate = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [min_value, setMinValue] = useState(1);

  const redirect = () => {
    history.push("/tickets");
  };

  const getData = async (id) => {
    const response = await getTicketDetail(id);
    const data = response.data;
    setFormData({
      code: data.code,
      client: data.client.code,
      client_name: data.client.full_name,
      state: data.status,
      total: data.total.toLocaleString("es-CO"),
      created_date: data.created_date,
      animal_number: data.animal_number,
    });
    if (data.value_paid % (data.total / data.animal_number) === 0) {
      setMinValue(data.value_paid / (data.total / data.animal_number));
    }
    if (data.value_paid === 0) {
      setMinValue(1);
    }
  };

  useEffect(() => {
    getData(id);
  }, [id]);

  const [formData, setFormData] = useState({
    code: "",
    client: "",
    client_name: "",
    state: "",
    total: "",
    created_date: "",
    animal_number: "",
  });

  const {
    code,
    client,
    client_name,
    state,
    total,
    created_date,
    animal_number,
  } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(
      ticketUpdate(id, {
        client: client,
        created_date: created_date,
        animal_number: parseInt(animal_number),
      })
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Tickets </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Tickets"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.ticketUpdated.code ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  El ticket # {props.ticketUpdated.code} se ha actualizado
                  correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Actualizar ticket</h2>
                </CardTitle>
                <CardBody>
                  <Form>
                    <Row className="justify-content-md-center">
                      <Col lg={6}>
                        <p>Información del ticket # {code}</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={2}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Código"
                              name="client"
                              id="client"
                              value={client}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="client">Código</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Nombre completo"
                              name="client_name"
                              id="client_name"
                              value={client_name}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="client_name">Nombre completo</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-pulse bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Estado"
                              name="state"
                              id="state"
                              value={state}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="state">Estado</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-dollar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Total"
                              name="total"
                              id="total"
                              value={total}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="total">Total</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-calendar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="date"
                              className="form-control"
                              placeholder="Fecha"
                              name="created_date"
                              id="created_date"
                              value={created_date}
                              onChange={onChange}
                              required
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="created_date">Fecha</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-spreadsheet bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="number"
                              className="form-control"
                              placeholder="Número de bovinos"
                              name="animal_number"
                              id="animal_number"
                              value={animal_number}
                              min={min_value}
                              onChange={onChange}
                              required
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="animal_number">Número de bovinos</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-4 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/tickets">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Actualizar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, ticketUpdated } = state.Billing;
  return { error, loading, ticketUpdated };
};

export default withRouter(connect(mapStateToProps)(TicketUpdate));
